import { Component, HostListener, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PopupButton } from '../app-popup/app-popup.component';
import { MatListModule } from '@angular/material/list';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-notification-popup',
  standalone: true,
  imports: [MatDialogModule, MatListModule, MatTableModule, NgIf, NgFor],
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
})
export class NotificationPopupComponent {
  displayedColumns: string[] = [
    'GEOGRAPHY',
    'CREATED',
    'UPDATED',
    'DELETED',
    'FAILED',
    'NOCHANGE',
  ];
  dataSource: MatTableDataSource<any>;
  buttonId: string;
  isButtonDisabled = false;
  buttonIdToDisable: string;
  urlDomain: any;
  projectId: any;
  productId: any;
  projectLink: any;
  productLink: any;
  tableData: any = [];
  deleteMessage: any;
  isClaimOrderUpdated = false;
  claimLA: any;
  project: any;
  product: any;

  constructor(
    public dialogRef: MatDialogRef<NotificationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public buttondata: PopupButton,
    private router: Router
  ) {
    this.tableData.push(data);
    this.isClaimOrderUpdated = data?.isClaimOrderUpdated
      ? data?.isClaimOrderUpdated
      : false;
    console.log('data', this.data);
    console.log('table data', this.tableData);
  }

  isDisabled: boolean;
  ngOnInit(): void {
    this.urlDomain = localStorage.getItem('urlDomain');
    this.projectId = this.data.project_id;
    this.productId = this.data.product_id;
    this.projectLink =
      'https://' +
      this.urlDomain +
      '/ui/#t/0TB000000000733/V2C/' +
      this.projectId;
    this.productLink =
      'https://' +
      this.urlDomain +
      '/ui/#t/0TB00000000R001/V18/' +
      this.productId;
    const geography = this.data.Geography;
    // assume result is an array of objects
    const resultTable: any = [];
    this.project = this.data.projectName;
    this.product = this.data.productName;
    this.tableData.forEach((data) => {
      const response = data;
      console.log('resp', response);

      if (response.type == 'claim') {
        this.claimLA = 'claims';
      } else {
        this.claimLA = 'local adptations';
      }
      resultTable.push({
        GEOGRAPHY: data.GEOGRAPHY == '' ? '' : data.Geography,
        SUCCESS:
          response.result?.SUCCESS != undefined ? response.result?.SUCCESS : 0,
        WARNING:
          response.result?.WARNING != undefined ? response.result?.WARNING : 0,
        FAILURE:
          response.result?.FAILURE == undefined
            ? response.PARTIAL?.length
            : response.result?.FAILURE + response.PARTIAL.length,
        FAILED_TEXT: response.FAILURE,
        ASSESSED: response.ASSESSED,
        PARTIAL: response.PARTIAL,
        DELETED: response.DELETED
          ? response.DELETED
          : response?.deletedCount ?? 0,
        NOCHANGE: response.NO_CHANGE,
      });
    });

    this.dataSource = new MatTableDataSource(resultTable);
  }

  @HostListener('document:keydown.enter')
  submit() {
    if (this.data.submitButtonId) {
      this.dialogRef.close(this.data.submitButtonId);
    }
  }

  close(buttonId: string) {
    this.dialogRef.close(buttonId);
  }

  navigate(buttonId) {
    if (buttonId == 'Home') {
      this.router.navigate(['/home']);
    } else if (buttonId == 'Project') {
      this.router.navigate(['/home']);
    } else if (buttonId == 'edit-Home') {
      this.router.navigate(['/edit-claims-la']);
    } else if (buttonId == 'edit-project') {
      this.router.navigate(['/edit-claims-la']);
    }
    this.dialogRef.close(buttonId);
  }

  oncancelClick() {
    this.dialogRef.close(false);
  }
}
